import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-responsive-modal';


class TopCategory extends Component {
    render() {
        const { product, themeLayoutId } = this.props;
       // 
        return (
            <>
            {/* Fashion */}
            {themeLayoutId === "L01" && 
            <div className="product-box">
                <div className="img-wrapper">
                    <div className="lable-block">
                        {(product.Title.APC_ELEMENT_CONTENT) ? <span className="lable5"> {product.Title.APC_ELEMENT_CONTENT}   </span> : ''}
                    </div>
                    <div className="front">
                        <Link to={`/${product.Link.APC_ACTION_TYPE}/${product.Link.BRAND_LIST}/${product.Link.APC_ACTION_URL}`}><img
                            src={`${
                                product.Image ?
                                    product.Image.APC_ELEMENT_CONTENT
                                    : product.SKU_IMAGE
                                }`}
                            className="img-fluid"
                            alt="" />
                            </Link>
                    </div>
                </div>
                {/* <div className="product-detail">
                    <div>
                        <div className="rating">
                               Hello
                            </div>
                    </div>
                </div> */}
               </div>
               }
               {/* end Fashion */}

               {/* Furniture */}

               {themeLayoutId === "L02" && 
                <div className="product-box p-t-2">
                    <div className="img-wrapper">
                        {/* <div className="lable-block">
                            {(product.Title.APC_ELEMENT_CONTENT) ? <span className="lable5"> {product.Title.APC_ELEMENT_CONTENT}   </span> : ''}
                        </div> */}
                        <div className="front">
                            <Link to={`/${product.Link.APC_ACTION_TYPE}/${product.Link.APC_ACTION_URL}`}>
                            <img
                                src={`${
                                    product.Image ?
                                        product.Image.APC_ELEMENT_CONTENT
                                        : product.SKU_IMAGE
                                    }`}
                                className="img-fluid"
                                alt="" />
                                </Link>
                        </div>
                    </div>
                    {/* <div className="product-detail">
                        <div>
                            <div className="rating">
                                Hello
                                </div>
                        </div>
                    </div> */}
                </div>
               }

               {/* end Furniture */}
               </>
        )
    }
}

export default TopCategory;